<template>
  <footer id="footer">
    <back-to-top bottom="50px" right="50px">
      <button type="button" class="btn btn-info btn-to-top">
   <i class='bx bx-up-arrow-alt' ></i>
      </button>
    </back-to-top>
    <!-- <div class="footer-newsletter">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-6">
                        <h4>Join Our Newsletter</h4>
                        <p>Tamen quem nulla quae legam multos aute sint culpa legam noster magna</p>
                        <form action="" method="post">
                            <input type="email" name="email"><input type="submit" value="Subscribe">
                        </form>
                    </div>
                </div>
            </div>
        </div> -->

    <div class="footer-top">
      <div class="container">
        <div class="row ">
          <div
            class="col-lg-4 col-md-6 col-12 footer-contact d-flex justify-content-center"
          >
          
            <p class="pl-3 ">
                 <span><img src="@/assets/img/logo-white.png" width="200" class="img-fluid mb-3"></img></span> <br>
                 Kerala Startup mission, <br/> 
                 Kinfra Hi-Tech Park,<br/> 
                 near Government Medical College,<br/> Kalamassery, Kochi, Kerala 683503. 
             
              <!-- 68 Kaki Bukit Avenue 6<br />
              #03-15
              ARK@KB<br />
              Singapore 417896 -->
              <br /><br>
              <!-- <strong>Phone:</strong> +1 5589 55488 55<br /> -->
              <strong>Email:</strong> talk@aixperia.com<br />
              <strong>Mobile:</strong>+91-9895874950<br />
            </p>
          </div>
          <img src="" alt="" />
          <div class="col-lg-4 col-md-6 col-6 footer-links">
            <h4>Useful Links</h4>
            <ul>
              <li><router-link to="/" class="no-active-footer">Home</router-link></li>
              <li><router-link to="/about" class="no-active-footer">About Us</router-link></li>
              <li><router-link to="/user-agreement" class="no-active-footer" >Terms and Conditions and User Agreement</router-link></li>
               <li><router-link to="/privacy-policy" class="no-active-footer" >Privacy Policy</router-link></li>
               <li><router-link to="/terms" class="no-active-footer" >Intellectual Property Terms</router-link></li>
              <li><router-link to="/refund-policy" class="no-active-footer" >Refund Policy</router-link></li>
              <li><router-link to="/return-shipping-policy" class="no-active-footer" >Return and Shipping Policy</router-link></li>

            </ul>
          </div>

          <div class="col-lg-4 col-md-6 col-6 footer-links">
            <h4>Our Products</h4>
            <ul>
              <li><router-link to="/cloud-design" class="no-active-footer" >3D Cloud Design</router-link></li>
              <li><router-link to="/3d-model" class="no-active-footer">3D Models & Viewer</router-link></li>
              <li><router-link to="/virtual" class="no-active-footer">360º Virtual Showroom</router-link></li>
              <li><router-link to="/studio" class="no-active-footer">Photo & Video Studio</router-link></li>
              <li><router-link to="/content" class="no-active-footer">Content Creation </router-link></li>
              <div class="d-flex justify-content-between align-items-center flex-nowrap">
                <div class="pe-2">
                  <img src="@/assets/img/brands/startupindia.png" class="img-fluid" alt="Startup India Logo" style="max-height: 60px;">
                </div>
                <div class="px-2">
                  <img src="@/assets/img/brands/keralastartupmission.png" class="img-fluid" alt="Kerala Startup Mission Logo" style="max-height: 60px;">
                </div>
                <div class="ps-2">
                  <img src="@/assets/img/brands/nvidia.png" class="img-fluid" alt="NVIDIA Logo" style="max-height: 60px;">
                </div>
              </div>
            </ul>
          </div>
          <!-- 
                    <div class="col-lg-3 col-md-6 footer-links">
                        <h4>Our Social Networks</h4>
                        <p>Cras fermentum odio eu feugiat lide par naso tierra videa magna derita valies</p>
                        <div class="social-links mt-3">
                            <a href="#" class="twitter"><i class="bx bxl-twitter"></i></a>
                            <a href="#" class="facebook"><i class="bx bxl-facebook"></i></a>
                            <a href="#" class="instagram"><i class="bx bxl-instagram"></i></a>
                            <a href="#" class="google-plus"><i class="bx bxl-skype"></i></a>
                            <a href="#" class="linkedin"><i class="bx bxl-linkedin"></i></a>
                        </div>
                    </div> -->
          <div class="container py-4" style="border-top: 1px solid #fff">
            <div class="copyright">
              &copy; Copyright 2021 <strong><span>aixperia</span></strong>. All Rights
              Reserved
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <cookie-law theme="dark-lime">
  <div slot="message">
   <span>This website uses cookies in order to offer you the most relevant information. Please accept cookies for optimal performance.</span> 
  <span class="pl-1"><router-link to="/cookie-policy" class="text-white " target="_blank"><u>Read Our Cookie Policy</u> </router-link> </span>  
  </div>
</cookie-law> -->

  </footer>
</template>
<script>
import BackToTop from "vue-backtotop";
// import CookieLaw from 'vue-cookie-law'
export default {
  components: { BackToTop},
};
</script>
<style scoped>
.btn-to-top {
  width: 40px;
  height: 40px;
  padding: 4px 4px;
  font-size: 35px;
  line-height: 16px;
  background-color: #2a2a2a;
  border-radius: 50%;
  border: none;
}
</style>
